import { Link } from "react-router-dom";

/** Editorial layout shared by all legal pages. */
export default function LegalLayout({ eyebrow, title, intro, children, lastUpdated }) {
  return (
    <article className="max-w-[820px] mx-auto px-6 lg:px-10 pt-16 pb-24">
      <Link to="/" className="eyebrow inline-block mb-6 underline-offset-4 hover:underline">
        ← BAYO
      </Link>
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h1 className="font-serif-display text-5xl sm:text-6xl leading-[1.02] tracking-tight mb-6">
        {title}
      </h1>
      {intro && (
        <p className="text-base sm:text-lg text-[color:var(--ink-2)] leading-relaxed max-w-[640px] mb-12 italic font-serif-display">
          {intro}
        </p>
      )}
      <div className="legal-prose">{children}</div>
      {lastUpdated && (
        <p className="text-xs uppercase tracking-[0.22em] text-[color:var(--ink-3)] mt-16 pt-8 border-t border-[color:rgba(0,16,48,0.08)]">
          Dernière mise à jour · {lastUpdated}
        </p>
      )}
    </article>
  );
}
